import Popper from 'vue3-popper'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('Popper', Popper)
})
